module.exports = __webpack_public_path__ + "img/jokes.cb949be6.png";